import { render, staticRenderFns } from "./template-home.app.vue?vue&type=template&id=ff2c4666&"
import script from "./template-home.app.vue?vue&type=script&lang=js&"
export * from "./template-home.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports